<template>
  <div id="login">
    <a-row type="flex" justify="center" align="middle">
      <a-col :span="12">
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item v-bind="formItemLayout">
            <span slot="label">
              Name&nbsp;
              <a-tooltip title="What do you want others to call you?">
                <a-icon type="question-circle-o" />
              </a-tooltip>
            </span>
            <a-input
              v-decorator="[
                'name',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your name!',
                      whitespace: true
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="E-mail">
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!'
                    },
                    {
                      required: true,
                      message: 'Please input your E-mail!'
                    }
                  ]
                }
              ]"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Password">
            <a-input
              v-decorator="[
                'password',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your password!'
                    },
                    {
                      validator: validateToNextPassword
                    }
                  ]
                }
              ]"
              type="password"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Confirm Password">
            <a-input
              v-decorator="[
                'confirm',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please confirm your password!'
                    },
                    {
                      validator: compareToFirstPassword
                    }
                  ]
                }
              ]"
              type="password"
              @blur="handleConfirmBlur"
            />
          </a-form-item>
          <a-form-item v-bind="formItemLayout" label="Phone Number">
            <a-input
              v-decorator="[
                'phone',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your phone number!'
                    }
                  ]
                }
              ]"
              style="width: 100%"
            >
              <a-select slot="addonBefore" v-decorator="['prefix', { initialValue: '+01' }]" style="width: 70px">
                <a-select-option value="+01">
                  +01
                </a-select-option>
                <a-select-option value="+02">
                  +02
                </a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
          <!-- <a-form-item
            v-bind="formItemLayout"
            label="Captcha"
            extra="We must make sure that your are a human."
          >
            <a-row :gutter="8">
              <a-col :span="12">
                <a-input
                  v-decorator="[
                    'captcha',
                    {
                      rules: [
                        {
                          required: true,
                          message: 'Please input the captcha you got!'
                        }
                      ]
                    }
                  ]"
                />
              </a-col>
              <a-col :span="12">
                <a-button>Get captcha</a-button>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item v-bind="tailFormItemLayout">
            <a-checkbox
              v-decorator="['agreement', { valuePropName: 'checked' }]"
            >
              I have read the
              <a href="">
                agreement
              </a>
            </a-checkbox>
          </a-form-item> -->
          <a-form-item v-bind="tailFormItemLayout">
            <a-button type="primary" html-type="submit">
              Register
            </a-button>
          </a-form-item>
        </a-form>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      confirmDirty: false,
      autoCompleteResult: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        }
      },
      tailFormItemLayout: {
        wrapperCol: {
          xs: {
            span: 24,
            offset: 0
          },
          sm: {
            span: 16,
            offset: 8
          }
        }
      }
    };
  },
  computed: {
    ...mapState(["UserPool", "PoolData", "UserName"])
  },
  methods: {
    ...mapMutations(["saveUserName"]),
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFieldsAndScroll((err, values) => {
        const attributeList = [];
        let dataEmail = {
          Name: "email",
          Value: values.email
        };
        let dataPhoneNumber = {
          Name: "phone_number",
          Value: values.prefix + values.phone
        };
        let dataName = {
          Name: "name",
          Value: "name"
        };

        const attributeEmail = new CognitoUserAttribute(dataEmail);
        const attributePhoneNumber = new CognitoUserAttribute(dataPhoneNumber);
        const attributeName = new CognitoUserAttribute(dataName);

        attributeList.push(attributeEmail);
        attributeList.push(attributePhoneNumber);
        attributeList.push(attributeName);
        this.UserPool.signUp(values.name, values.password, attributeList, null, (err, result) => {
          if (err) {
            alert(err.message || JSON.stringify(err));
            return;
          }
          var cognitoUser = result.user;
          this.$message.success("User Successfully Registered!");
          setTimeout(() => {
            this.$router.push({ path: "/login" });
          }, 1000);
          this.saveUserName(cognitoUser.getUsername());
        });
      });
    },
    handleConfirmBlur(e) {
      const value = e.target.value;
      this.confirmDirty = this.confirmDirty || !!value;
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue("password")) {
        callback("Passwords do not match!");
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(["confirm"], { force: true });
      }
      callback();
    },
    handleWebsiteChange(value) {
      let autoCompleteResult;
      if (!value) {
        autoCompleteResult = [];
      } else {
        autoCompleteResult = [".com", ".org", ".net"].map(domain => `${value}${domain}`);
      }
      this.autoCompleteResult = autoCompleteResult;
    }
  }
};
</script>

<style lang="less" scoped>
#login {
  height: 100%;
  .ant-btn-primary {
    width: 100%;
  }
  > div {
    height: 100%;
  }
  > form {
    max-width: 600px;
  }
}
</style>
